var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "profileBackground",
      staticStyle: { "padding-top": "20vh", height: "50vh" },
      attrs: { fluid: "" }
    },
    [
      _c(
        "center",
        [
          _c(
            "v-card",
            { staticClass: "card" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { lg6: "", md6: "", sm12: "", xs12: "" } },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticClass: "avatarStyle",
                          attrs: {
                            size: "180px",
                            color: _vm.businessInfo.color
                          }
                        },
                        [
                          _vm.businessInfo.url
                            ? _c("img", {
                                attrs: {
                                  src: this.$store.getters.signed_in_user.url,
                                  alt: "avatar"
                                }
                              })
                            : _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "20em",
                                      color: "white"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.initial()))]
                                )
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.onEdit
                        ? _c(
                            "p",
                            {
                              staticClass: "subheading text",
                              staticStyle: {
                                "margin-top": "2vh",
                                "margin-left": "3vw",
                                "font-weight": "lighter",
                                "margin-right": "3vw",
                                "align-content": "center"
                              }
                            },
                            [
                              _vm._v(
                                "\n                Share Yourself Artists\n              "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { lg6: "", md6: "", sm12: "", xs12: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "infoContainer" },
                        [
                          !_vm.onEdit
                            ? _c(
                                "h1",
                                _vm._b(
                                  {
                                    staticClass: "display-2 text",
                                    staticStyle: {
                                      "margin-bottom": "2vh",
                                      "font-weight": "lighter"
                                    }
                                  },
                                  "h1",
                                  _vm.businessInfo.name,
                                  false
                                ),
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.fetchUserName) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Name" },
                                    model: {
                                      value: _vm.editInfo.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editInfo, "name", $$v)
                                      },
                                      expression: "editInfo.name"
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticClass: "subheading text",
                              staticStyle: { "margin-bottom": "2vh" }
                            },
                            [_vm._v("Business")]
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "text",
                              staticStyle: {
                                "margin-top": "3vh",
                                "text-align": "left"
                              }
                            },
                            [_vm._v("Email: " + _vm._s(_vm.fetchUserEmail))]
                          ),
                          _vm._v(" "),
                          !_vm.onEdit
                            ? _c(
                                "div",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "Publication: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .publication
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "Follower Count: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .follower_count
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "Website: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .website
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "About: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .about
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "Worth Knowing: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .worth_knowing
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "Additional Notes: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .additional_notes
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text",
                                      staticStyle: { "margin-top": "3vh" }
                                    },
                                    [
                                      _vm._v(
                                        "Instagram: " +
                                          _vm._s(
                                            this.$store.getters.signed_in_user
                                              .instagram
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Publication" },
                                    model: {
                                      value: _vm.editInfo.publication,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editInfo,
                                          "publication",
                                          $$v
                                        )
                                      },
                                      expression: "editInfo.publication"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Follower Count" },
                                    model: {
                                      value: _vm.editInfo.follower_count,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editInfo,
                                          "follower_count",
                                          $$v
                                        )
                                      },
                                      expression: "editInfo.follower_count"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Website" },
                                    model: {
                                      value: _vm.editInfo.website,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editInfo, "website", $$v)
                                      },
                                      expression: "editInfo.website"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "About" },
                                    model: {
                                      value: _vm.editInfo.about,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editInfo, "about", $$v)
                                      },
                                      expression: "editInfo.about"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Worth Knowing" },
                                    model: {
                                      value: _vm.editInfo.worth_knowing,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editInfo,
                                          "worth_knowing",
                                          $$v
                                        )
                                      },
                                      expression: "editInfo.worth_knowing"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Additional Notes" },
                                    model: {
                                      value: _vm.editInfo.additional_notes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editInfo,
                                          "additional_notes",
                                          $$v
                                        )
                                      },
                                      expression: "editInfo.additional_notes"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: { label: "Add/Change Instagram" },
                                    model: {
                                      value: _vm.editInfo.instagram,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editInfo, "instagram", $$v)
                                      },
                                      expression: "editInfo.instagram"
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "text",
                              staticStyle: {
                                "margin-top": "3vh",
                                "text-align": "left"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getPassedTime(_vm.fetchUserSignUpDate)
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.onEdit
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    depressed: "",
                                    block: "",
                                    outline: "",
                                    flat: "",
                                    color: _vm.fetchUserColor
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.setEdit($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Edit\n              "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.onEdit
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    depressed: "",
                                    block: "",
                                    outline: "",
                                    flat: "",
                                    color: _vm.fetchUserColor
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.exit($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Back\n              "
                                  )
                                ]
                              )
                            : _c(
                                "v-flex",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        depressed: "",
                                        block: "",
                                        outline: "",
                                        flat: "",
                                        color: _vm.fetchUserColor,
                                        loading: _vm.dataNotSent,
                                        disabled: _vm.dataNotSent
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.sendEditData($event)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Submit\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        depressed: "",
                                        block: "",
                                        outline: "",
                                        flat: "",
                                        color: _vm.fetchUserColor
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.resetEdit($event)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Back\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d06e39", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d06e39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/business_profile.vue
// module id = null
// module chunks = 